import { ContractAddress } from '../constants';
import { buildAccessPassNfts } from './access-pass/access-pass.nft-config';
import { buildCommunityContestNfts } from './community-contests/community-contests.nft-config';
import ed9e_0_robprior from './metadata/ed9e_0_robprior.metadata';
import { buildMoviesNfts } from './movies/movies.nft-config';
import type { MogulNFTToken } from './nft.types';
import { translateMetadata } from './translate-nft-metadata.util';

const NFTS_MAP: { [key: string]: MogulNFTToken & { label: string } } = {
  ED9E_0_ROB_PRIOR: {
    contractAddress: ContractAddress.MogulNft,
    id: 0,
    label: 'ROB_PRIOR',
    metadataRaw: JSON.stringify(ed9e_0_robprior),
    metadata: translateMetadata(JSON.stringify(ed9e_0_robprior)),
  },
};

const ACCESS_PASS_NFTS = buildAccessPassNfts();
const COMMUNITY_CONTEST_NFTS = buildCommunityContestNfts();
const MOVIE_NFTS = buildMoviesNfts();
const NFTS_ARRAY = [
  NFTS_MAP.ED9E_0_ROB_PRIOR,
  ...ACCESS_PASS_NFTS,
  ...COMMUNITY_CONTEST_NFTS,
  ...MOVIE_NFTS,
];

NFTS_ARRAY.forEach(nft => (NFTS_MAP[nft.label] = nft));

export const NFTS = {
  ...NFTS_MAP,
  ORDERED: NFTS_ARRAY,
  ACCESS_PASSES: ACCESS_PASS_NFTS,
  COMMUNITY_CONTESTS: COMMUNITY_CONTEST_NFTS,
  MOVIES: MOVIE_NFTS,
  COUNT: NFTS_ARRAY.length,
};
